/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityMappingResult
 */
export interface ControlEntityMappingResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityMappingResult
     */
    asset?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityMappingResult
     */
    sources?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlEntityMappingResult
     */
    extra?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ControlEntityMappingResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityMappingResult
     */
    updated?: string;
}

/**
 * Check if a given object implements the ControlEntityMappingResult interface.
 */
export function instanceOfControlEntityMappingResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityMappingResultFromJSON(json: any): ControlEntityMappingResult {
    return ControlEntityMappingResultFromJSONTyped(json, false);
}

export function ControlEntityMappingResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityMappingResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'sources': !exists(json, 'sources') ? undefined : json['sources'],
        'extra': !exists(json, 'extra') ? undefined : json['extra'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function ControlEntityMappingResultToJSON(value?: ControlEntityMappingResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'sources': value.sources,
        'extra': value.extra,
        'created': value.created,
        'updated': value.updated,
    };
}

